var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3336 16.666V3.33267C13.3336 2.89064 13.158 2.46672 12.8454 2.15416C12.5328 1.84159 12.1089 1.666 11.6668 1.666H8.3332C7.89114 1.666 7.46718 1.84159 7.15459 2.15416C6.84201 2.46672 6.6664 2.89064 6.6664 3.33267V16.666M3.3328 4.99933H16.6672C17.5877 4.99933 18.334 5.74553 18.334 6.666V14.9993C18.334 15.9198 17.5877 16.666 16.6672 16.666H3.3328C2.41225 16.666 1.666 15.9198 1.666 14.9993V6.666C1.666 5.74553 2.41225 4.99933 3.3328 4.99933Z",
    stroke: "#182553",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase20);
export default __webpack_public_path__ + "static/media/briefcase-20.1254957c1eef83bfb1bcba59e4046fda.svg";
export { ForwardRef as ReactComponent };